import React from 'react';
import { useNavigate } from 'react-router';
import {
  bottomNavStyle,
  bottomNavItemStyle,
  bottomNavSelectedItemStyle,
  bottomNavIconStyle,
  bottomNavLabelStyle,
} from '../../layouts/LoggedLayout.styles';

interface MobileNavItem {
  key: string;
  icon: React.ReactNode;
  label: string;
}

interface MobileBottomNavProps {
  items: MobileNavItem[];
  selectedKey: string;
  accentColor?: string;
}

/**
 * Mobile bottom navigation component
 * Displays a fixed navigation bar at the bottom of the screen on mobile devices
 * Shows only icons for unselected items and both icon and label for the selected item
 */
const MobileBottomNav: React.FC<MobileBottomNavProps> = ({
  items,
  selectedKey,
  accentColor = '#ee8865',
}) => {
  const navigate = useNavigate();

  const handleItemClick = (path: string) => {
    navigate(path);
  };

  return (
    <div style={bottomNavStyle} role="navigation" aria-label="Mobile navigation">
      {items.map(item => {
        const isSelected =
          item.key === '/'
            ? selectedKey === '/' || selectedKey === ''
            : selectedKey.startsWith(item.key);

        return (
          <div
            key={item.key}
            style={isSelected ? bottomNavSelectedItemStyle : bottomNavItemStyle}
            onClick={() => handleItemClick(item.key)}
            role="button"
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleItemClick(item.key);
              }
            }}>
            {React.cloneElement(item.icon as React.ReactElement, {
              style: {
                ...bottomNavIconStyle,
                color: isSelected ? accentColor : '#000000',
              },
            })}
            <span
              style={{
                ...bottomNavLabelStyle,
                color: isSelected ? accentColor : '#000000',
                opacity: isSelected ? 1 : 0,
                height: isSelected ? 'auto' : 0,
                overflow: 'hidden',
              }}>
              {item.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default MobileBottomNav;
